import ownKeys from './ownKeys';

export default function hasGeneratorInterface(handler) {
  var keys = ownKeys(handler);
  var hasOnlyInterfaceNames = keys.every(function (ownKey) {
    return ownKey === 'next' || ownKey === 'throw';
  });
  return keys.length && keys.length <= 2 && hasOnlyInterfaceNames;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/hasGeneratorInterface.js
// module id = ./node_modules/redux-actions/es/utils/hasGeneratorInterface.js
// module chunks = 6 9 11